import React, { useState } from "react";
import { Button } from "react-bootstrap"
// import Logo2 from "../../assets/images/BPPMHKP.png";
import LogoSiapmutu from "../../assets/images/brand/siapmutu-logo-compact.png";
import './styles/landing.css';
import { useNavigate } from "react-router-dom";
// import {FaSearch} from "react-icons/fa";

const Navigation = () => {
  const [activeLink, setActiveLink] = useState("#features");

  const handleSetActive = (hash) => {
    if (hash === "#header") {
      setActiveLink(null);
    } else {
      setActiveLink(hash);
    }
  };;
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-expand-lg navbar-light fixed-top landing-nav">
      <div className="container">
        <a className="navbar-brand landing-brand"
          href="#header"
          onClick={() => handleSetActive("#header")} >

          <img
            src={LogoSiapmutu}
            className="img-responsive landing-brand-logo"
            alt="SIAPMUTU - Sistem Informasi dan Aplikasi Pelayanan Mutu"
          />
          {/* <span className="landing-brand-divider" aria-hidden="true" />
          <img
            src={Logo2}
            className="img-responsive landing-brand-agency"
            alt="BPPMHKP - Badan Mutu KKP"
          /> */}
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="true"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-lg-center landing-menu">
            <li className="nav-item">
              <a
                className={`nav-link ${activeLink === "#features" ? "active" : ""}`}
                href="#features"
                onClick={() => handleSetActive("#features")}
              >
                Fitur
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeLink === "#about" ? "active" : ""}`}
                href="#about"
                onClick={() => handleSetActive("#about")}
              >
                Tentang
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeLink === "#services" ? "active" : ""}`}
                href="#services"
                onClick={() => handleSetActive("#services")}
              >
                Tugas
              </a>
            </li>
            <li className="nav-item landing-cta">
              <Button
                as="a"
                className="nav-link no-after btn-landing-outline"
                onClick={() => navigate("/val-smkhp")}
                type="button"
              > <i className="fa fa-search"></i>
                Penelusuran SMKHP
              </Button>
            </li>
            <li className="nav-item landing-cta">
              <Button as="a"
                className="nav-link no-after btn-landing-primary"
                onClick={() => navigate("/login")}
                type="button"
              >
                <i className="fa fa-sign-in-alt"></i>
                Login
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
